module.exports = function (md) {
  const expectOpener = '<!--';
  const expectCloser = '-->';

  md.block.ruler.after(
    'lheading',
    'comment_block',
    (state, startLine, endLine, silent) => {
      let pos = state.bMarks[startLine] + state.tShift[startLine];
      let max = state.eMarks[startLine];

      let lineText = state.src.slice(pos, max);
      if (!lineText.includes(expectOpener)) {
        return false;
      }

      if (silent) {
        return false;
      }

      let nextLine = startLine + 1;
      if (!lineText.includes(expectCloser)) {
        for (; nextLine < endLine; nextLine++) {
          if (state.tShift[nextLine] < state.blkIndent) {
            break;
          }

          pos = state.bMarks[nextLine] + state.tShift[nextLine];
          max = state.eMarks[nextLine];
          lineText = state.src.slice(pos, max);

          if (lineText.includes(expectCloser)) {
            if (lineText.length !== 0) {
              nextLine++;
            }

            break;
          }
        }
      }

      state.line = nextLine;

      const token = state.push('html_block', '', 0);
      token.map = [startLine, nextLine];
      token.content = state.getLines(
        startLine,
        nextLine,
        state.blkIndent,
        true
      );

      return true;
    }
  );
};
